"use strict";

export function fixTabindex($slider) {
    $slider.on('init', function(event, slick) {
        let $slide = slick.$slides.first();
        setTimeout(function () {
            $slide.find('[tabindex="-1"]').attr('tabindex', '0');
        }, 10);
    });

    $slider.on('afterChange', function(event, slick, currentSlide) {
        let $slide = slick.$slides.eq(currentSlide);
        setTimeout(function () {
            let $elements = $slide.find('[tabindex="-1"]');
            $elements.attr('tabindex', '0');
            $elements.first().focus();
        }, 10)
    });
}

export function fixButtonDisabledState($slider) {
    $slider.on('init', function(event, slick) {
        if (slick.currentSlide === 0) {
            slick.$prevArrow.attr('disabled', 'disabled');
        } else if (slick.currentSlide + 1 >= slick.slideCount) {
            slick.$nextArrow.attr('disabled', 'disabled');
        }
    });

    $slider.on('afterChange', function(event, slick, currentSlide) {
        let $prevButton = slick.$prevArrow;
        let $nextButton = slick.$nextArrow;

        if (currentSlide === 0) {
            $prevButton.attr('disabled', 'disabled');
        } else {
            $prevButton.removeAttr('disabled');
        }

        if (currentSlide + 1 >= slick.slideCount) {
            $nextButton.attr('disabled', 'disabled');
        } else {
            $nextButton.removeAttr('disabled');
        }
    });
}